import VLApi from "@/api/VLApi";
import { useWebportalStore } from "@/stores/webportal";

// function to compare version numbers
const compare = (a: string, b: string) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base'})
// smallest packaged version that supports the API version
const compatibleVersion = (versions: string[], target: string) =>
    [...versions].sort(compare).find(v => compare(v, target) >= 0);

export default async function checkVersion() {
    if (!navigator.onLine) {
        return;
    }

    const baseTest = window.location.pathname.match(/(.*\/)/);
    let base = baseTest ? baseTest[1] : '/';
    const versionIndex = base.indexOf("version");
    if (versionIndex > -1) {
        base = base.substring(0, versionIndex);
    }

    // get all available app versions
    const appVersions = (await fetch(`${base}appVersions.json`).then(r => r.ok ? r.json() : null).catch(e => console.info(e)));
    if (!appVersions) {
        return;
    }
    // get current vl api version, 
    const vlApiVersion = await VLApi.get(`${useWebportalStore().vlApiUrl}/ApiVersion`).then(r => r.data.data.trim());
    const sortedVersions = [...appVersions].sort(compare);
    const maxPackaged = sortedVersions[sortedVersions.length - 1];
    let version = compatibleVersion(appVersions, vlApiVersion);

    let target: string;
    if (!version || compare(vlApiVersion, maxPackaged) > 0) {
        version = 'latest';
        target = base;
    } else {
        target = `${base}version/${version}/index.html`;
    }

    if (window.location.pathname != target) {
        window.location.pathname = target;
    }
    
    window.localStorage.setItem("vlApiVersion", vlApiVersion)
    window.localStorage.setItem("version", version)
    
    useWebportalStore().vlApiVersion = vlApiVersion
    useWebportalStore().version = version
}